<section class="aarni-font w-full shadow border-b mt-[80px] py-[50px]">
    <div class="container mx-auto px-4">
        <h1 class=" text-center md:text-start font-bold text-[32px]">
            {{ pageTitle }}
        </h1>
    </div>
</section>

<section class="aarni-font">
    <div class="container mx-auto flex flex-col lg:flex-row gap-8 py-12 px-4">
        <aside class="w-full lg:w-1/4 space-y-4 md:max-h-screen md:overflow-y-auto overflow-x-hidden pr-2">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">B.Tech EE Specialisations</h2>
                    <div class="">
                        <a
                            [href]="'schools/arni-school-of-technology/btech-ee/electric-vehicle'"
                            [ngClass]="{'text-white bg-blue-600' : pageTitle === 'BTech EE in Electric Vehicle', 'text-blue-600 bg-white' : pageTitle !== 'BTech EE in Electric Vehicle'}"
                            class="flex items-center space-x-2 p-3 w-full border-y border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Electric Vehicle</span>
                        </a>
                    </div>
                </div>
            </div>
            <h2 class="text-lg font-semibold mb-4 hidden lg:block">Quick Links</h2>
            <div class="bg-white p-4 rounded-lg shadow  hidden lg:block border-gray-200 border-2 ">
                <div class="space-y-2">
                    <a href="/about/faculty" class="flex items-center  space-x-3 p-2 rounded-lg">
                        <div>
                              <span
                                  class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium   md:text-[16px] xl:text-xl ">Faculty</span>
                    </a>
                </div>
            </div>
            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2 ">
                <div class="space-y-2">
                    <a href="/quick-links/student-testimonial" class="flex items-center space-x-3 p-2 rounded-lg">
                        <div>
                             <span
                                 class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium  md:text-[16px] xl:text-xl ">Testimonials</span>
                    </a>
                </div>
            </div>
            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/about/leadership/chancellor" class="flex items-center space-x-3 p-2 rounded-lg ">
                        <div>
                               <span
                                   class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                                    <i class="fa fa-phone text-2xl"></i>
                              </span>
                        </div>

                        <span class="text-gray-700 font-medium  md:text-[16px] xl:text-xl ">Leadership</span>
                    </a>
                </div>
            </div>
            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/contact-us" class="flex items-center space-x-3 p-2 rounded-lg ">
                        <div>
                             <span
                                 class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-camera text-2xl"></i>
            </span>
                        </div>

                        <span class="text-gray-700 font-medium  md:text-[16px] xl:text-xl ">Contact Us</span>
                    </a>
                </div>
            </div>
        </aside>
        <div class="flex-1">
            <div class="md:p-12 shadow-lg border-gray-200 bg-white h-fit ">
                <h3 class="font-semibold text-[22px]">
                    {{ pageTitle }}
                </h3>
                <div *ngIf="pageTitle === 'BTech EE in Electric Vehicle'">
                    <p class="text-gray-500 text-justify my-3">Moving towards eco-friendly and sustainable
                        transportation is the need of the day! This transformation demands electric vehicles, the
                        e-vehicle industry for e-vehicle gaining popularity by each passing day. ARNI University is a
                        proud contributor to the green revolution with its specialized B. Tech in Electrical Engineering
                        (EE) with a focus on Electric Vehicles.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">A Bachelor of Technology (B. Tech) in Electrical
                        Engineering with a specialization in Electric Vehicle Technology at ARNI School of Technology is
                        a 4-year undergraduate degree program that focuses on the design, development, and
                        implementation of electric vehicle technology. Basic electrical engineering principles and
                        specific understanding of electromobility, such as battery management systems, electric drive
                        systems, power electronics, energy storage, charging infrastructure, and vehicle dynamics, are
                        perfectly combined in this course.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">At ARNI University, our programs are delivered by
                        knowledgeable academics and professionals in the field, and it is firmly based on current
                        business trends. Students can develop a solid portfolio and obtain real-world experience through
                        internships, innovation labs, and partnerships with EV manufacturers and startups.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">An introduction to electrical engineering, which covers
                        subjects like circuit analysis, electronics, power systems, and electromagnetics, usually opens
                        the program. After that, students go to more specialized courses in fields including power
                        electronics, motor control, battery technology, and electric vehicle design.
                    </p>
                    <p class="text-gray-500 text-justify mb-3">
                        Whether you aspire to work in design, research, production, or policymaking in the EV ecosystem,
                        this course offers a robust launchpad to power your career while contributing to a sustainable
                        planet.
                    </p>
                    <h3 class="font-semibold text-[18px] mt-4">
                        Course Objectives
                    </h3>
                    <ul class="list-disc my-3 text-gray-500 px-6">
                        <li>Develop skills and proficiency in core areas of Electrical and related multidisciplinary
                            Engineering fundamentals.
                        </li>
                        <li>Demonstrate technical competence to tackle problems in the field of industry using emerging
                            technologies, innovation, and entrepreneurial skills.
                        </li>
                        <li>To develop skills in design, modeling, and simulation of EV components and systems, offer
                            hands-on experience with battery testing, BMS, and EV drivetrains.
                        </li>
                        <li>To specialize students in electric vehicle systems, including motors, batteries, power
                            converters, and control systems.
                        </li>
                        <li>To encourage students for industry readiness through internships, live projects, and expert
                            mentorship. Additionally, promote research and innovation aligned with India’s EV mission
                            and global sustainability goals.
                        </li>
                        <li>Pursue higher education, research and development in electrical engineering and allied areas
                            of science and technology.
                        </li>
                    </ul>
                    <h3 class="font-semibold text-[18px] mt-4">
                        Scope
                    </h3>
                    <p class="text-gray-500 my-3">
                        Graduates with this specialization have numerous career options, including roles in automotive,
                        electric vehicle, research, and government agencies, and can prepare them for further education
                        in electrical, mechanical, or sustainable energy fields.
                    </p>
                    <ul class="list-disc my-3 text-gray-500 px-6">
                        <li>India is all set to target 10 million annual EV sales by 2030, ensuring rising industry
                            demands that open ample opportunities for degree holders to design, manufacture, test, and
                            maintain electronic vehicles.
                        </li>
                        <li> According to NITI Aayog, India aims to achieve 30% EV penetration by 2030, and the global
                            EV market is projected to reach $1.58 trillion by 2030 (Allied Market Research).
                        </li>
                        <li>The worldwide EV industry is growing at a CAGR of over 21.7% (MarketsandMarkets), leading to
                            job opportunities globally.
                        </li>
                        <li>Students can build their own ventures in EV manufacturing, retrofitting kits, or charging
                            station technologies.
                        </li>
                        <li>Graduates can pursue roles such as EV Design Engineer, Battery Management Engineer,
                            Powertrain Engineer, Charging Infrastructure Expert, and R&D Associate.
                        </li>
                    </ul>
                    <p class="text-gray-500 my-3">Join ARNI University and drive the future of sustainable
                        transportation. With our industry-aligned curriculum, hands-on learning, and expert mentorship,
                        you won’t just study electric vehicles—you’ll be part of the revolution that redefines mobility.
                        Be the change, engineer the future.
                    </p>
                </div>
            </div>
        </div>
    </div>

</section>
